



















import {Component, Vue} from "vue-property-decorator";
import {getPublicPath} from "@/shared/services/helper/utils";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import EnumLabel from "@/shared/components/EnumSelector/components/Label.vue";
import {PickingListTranshipmentParams, PickingListTranshipmentStore} from "@/modules/pickinglisttranshipment";
import PLTranshipmentDetail
    from "@/modules/pickinglisttranshipment/shared/component/PickingListTranshipmentDetail/index.vue";
import PLTranshipmentPrint
    from "@/modules/pickinglisttranshipment/shared/component/PickingListTranshipmentPrint/index.vue";
import ConfirmedPLTranshipmentSearch
    from "@/modules/pickinglisttranshipment/shared/component/ConfirmedPickingListTranshipmentSearch/index.vue";
import ConfirmedPLTranshipmentTable
    from "@/modules/pickinglisttranshipment/shared/component/ConfirmedPickingListTranshipmentTable/index.vue";

@Component({
    name: "ConfirmedTranshipment",
    components: {
        ConfirmedPLTranshipmentTable,
        ConfirmedPLTranshipmentSearch,
        PLTranshipmentPrint,
        PLTranshipmentDetail,
        EnumLabel
    }
})
export default class extends mixins(CommonMixin) {
    visible = false;
    id = null;
    printObj = {
        id: "picking-list-transhipments-print",
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`,
    };

    created() {
        PickingListTranshipmentStore.updatePickingListTranshipmentParams({ ...new PickingListTranshipmentParams() });
        PickingListTranshipmentStore.listConfirmedPickingListTranshipment(PickingListTranshipmentStore.params);
    }

    get pickingListTranshipments() {
        return PickingListTranshipmentStore.ids.map((id: number) => PickingListTranshipmentStore.data[id]);
    }

    onChangePage(pagination) {
        PickingListTranshipmentStore.listConfirmedPickingListTranshipment({ ...PickingListTranshipmentStore.params, page: pagination.current, limit: pagination.pageSize })
    }

    async seeDetail(id: number) {
        if (isNaN(id)) return;
        this.id = id as any;
        await PickingListTranshipmentStore.listBillLadingByPickingListTranshipment(this.id);
        this.visible = true;
    }

    async print(id: number) {
        if (isNaN(id)) return;
        this.id = id as any;
        await PickingListTranshipmentStore.listBillLadingByPickingListTranshipment(this.id);
        this.$print(this.printObj);
    }

    createConfirmedTranshipment() {
        this.$router.push({ name: "createConfirmedTranshipment" });
    }
}
